import { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import type { AppDispatch } from "./redux/store";
import { initializeCart } from "./redux/slices/cartSlice";
import { initializeWishlist } from "./redux/slices/wishlistSlice";

/**
 * Initializes the application state for cart and wishlist from localStorage.
 *
 * This component dispatches actions to initialize the cart and wishlist
 * using IDs retrieved from localStorage (if available) when the component mounts.
 * It does not render any UI.
 *
 * @returns null
 */
const AppInitializer = () => {
  const dispatch = useDispatch<AppDispatch>();
  const hasInitialized = useRef(false);

  useEffect(() => {
    if (hasInitialized.current) return;
    hasInitialized.current = true;

    const cartId = localStorage.getItem("cartId");
    const wishlistId = localStorage.getItem("wishlistId");
    dispatch(initializeCart(cartId || undefined));
    dispatch(initializeWishlist(wishlistId || undefined));
  }, [dispatch]);

  return null;
};
export default AppInitializer;
